import React from "react";
import { Provider } from "react-redux";
import { Router, Route } from "react-router-dom";
import history from "./history";
import App from "./App";
import WithAnalytics from "./Analytics";

const AppWithAnalytics = WithAnalytics(App);

const Root = ({ store }) => (
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={AppWithAnalytics} />
    </Router>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/modules/core/Root.js